module.exports = __webpack_public_path__ + "img/galeria-invertebrados1.29521866.jpg";